export default "__VITE_ASSET__504cd0a6__"